import { IConfiguration } from "@/interfaces/local";
import { isDev } from "@/tools/configuration";

class LocalApi {
  public async getLanguage(lang: string) {
    const result = await fetch("/languages/" + lang + ".json");
    return result.json();
  }

  public async getLocalConfiguration(): Promise<IConfiguration> {
    const result = await fetch("/configuration/config.json");
    const config: IConfiguration = await result.json();
    if (isDev) {
      config.api = {
        asi: "https://localhost:7155"
      };
    }
    return config;
  }
}

export const localApi = new LocalApi();
